const actions = {
  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // UI
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },
};

export default actions;
